import { createEnv } from "@t3-oss/env-core"
import { z } from "zod"

export const env = createEnv({
	/**
	 * The prefix that client-side variables must have. This is enforced both at
	 * a type-level and at runtime.
	 */
	clientPrefix: "VITE_",

	client: {
		// An explicit API base supports local proxies and deployments with a custom service path.
		VITE_ORGANIZATION_API_URL: z.string().min(1).optional(),
		VITE_APP_TITLE: z.string().min(1).optional(),
		VITE_SENTRY_DSN: z.string().min(1).optional(),
		VITE_SENTRY_ENV: z.string().min(1).optional(),
		VITE_SENTRY_TRACE_SAMPLE_RATE: z.coerce.number().optional().default(0.2),
		VITE_ENABLE_MOCK: z.coerce
			.string()
			.transform((val) => val === "true")
			.optional()
			.default(false),
	},

	/**
	 * What object holds the environment variables at runtime. This is usually
	 * `process.env` or `import.meta.env`.
	 */
	runtimeEnv: import.meta.env,

	/**
	 * By default, this library will feed the environment variables directly to
	 * the Zod validator.
	 *
	 * This means that if you have an empty string for a value that is supposed
	 * to be a number (e.g. `PORT=` in a ".env" file), Zod will incorrectly flag
	 * it as a type mismatch violation. Additionally, if you have an empty string
	 * for a value that is supposed to be a string with a default value (e.g.
	 * `DOMAIN=` in an ".env" file), the default value will never be applied.
	 *
	 * In order to solve these issues, we recommend that all new projects
	 * explicitly specify this option as true.
	 */
	emptyStringAsUndefined: true,
})
